import script from "./Post.vue?vue&type=script&lang=ts&setup=true"
export * from "./Post.vue?vue&type=script&lang=ts&setup=true"

import "./Post.vue?vue&type=style&index=0&id=74117fd1&scoped=true&lang=scss"
import "./Post.vue?vue&type=style&index=1&id=74117fd1&lang=scss"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74117fd1"]])

export default __exports__